var map = {
	"./1024": 53,
	"./1024.png": 53,
	"./Group 13416": 54,
	"./Group 13416.svg": 54,
	"./Logo": 55,
	"./Logo.svg": 55,
	"./Mask Group 1": 56,
	"./Mask Group 1.png": 56,
	"./Snack": 57,
	"./Snack.svg": 57,
	"./Twitter": 58,
	"./Twitter.png": 58,
	"./about-img": 59,
	"./about-img.webp": 59,
	"./about_us_1": 60,
	"./about_us_1.webp": 60,
	"./about_us_2": 61,
	"./about_us_2.webp": 61,
	"./about_us_3": 62,
	"./about_us_3.webp": 62,
	"./add": 63,
	"./add.svg": 63,
	"./back-arrow": 64,
	"./back-arrow.png": 64,
	"./back_arrow": 65,
	"./back_arrow.png": 65,
	"./banner": 46,
	"./banner-white-mode": 47,
	"./banner-white-mode.png": 47,
	"./banner-white-mode.webp": 150,
	"./banner.png": 46,
	"./banner.webp": 151,
	"./basic-logos/cancel": 66,
	"./basic-logos/cancel.svg": 66,
	"./basic-logos/empty-cart": 67,
	"./basic-logos/empty-cart.png": 67,
	"./basic-logos/loading": 68,
	"./basic-logos/loading-150": 69,
	"./basic-logos/loading-150.gif": 69,
	"./basic-logos/loading.gif": 68,
	"./basic-logos/no-image-1": 70,
	"./basic-logos/no-image-1.png": 70,
	"./basic-logos/success": 71,
	"./basic-logos/success.svg": 71,
	"./calendar": 48,
	"./calendar.png": 48,
	"./calendar.svg": 152,
	"./call": 72,
	"./call.png": 72,
	"./cart-orange": 73,
	"./cart-orange.png": 73,
	"./chownow": 74,
	"./chownow.svg": 74,
	"./clock": 75,
	"./clock.png": 75,
	"./default_banner_1": 76,
	"./default_banner_1.webp": 76,
	"./default_banner_2": 77,
	"./default_banner_2.webp": 77,
	"./default_banner_3": 78,
	"./default_banner_3.webp": 78,
	"./default_banner_4": 79,
	"./default_banner_4.webp": 79,
	"./delete": 80,
	"./delete.png": 80,
	"./dish-1": 81,
	"./dish-1.webp": 81,
	"./dish-2": 82,
	"./dish-2.webp": 82,
	"./dish-3": 83,
	"./dish-3.webp": 83,
	"./dish-4": 84,
	"./dish-4.webp": 84,
	"./dish-5": 85,
	"./dish-5.png": 85,
	"./dish-6": 86,
	"./dish-6.png": 86,
	"./doordash": 87,
	"./doordash.svg": 87,
	"./dribbble": 88,
	"./dribbble.png": 88,
	"./edit": 89,
	"./edit.svg": 89,
	"./email": 90,
	"./email.png": 90,
	"./facebook": 91,
	"./facebook.png": 91,
	"./food_plchldr": 92,
	"./food_plchldr.svg": 92,
	"./gallery-image1": 93,
	"./gallery-image1.webp": 93,
	"./gallery-image10": 94,
	"./gallery-image10.webp": 94,
	"./gallery-image2": 95,
	"./gallery-image2.webp": 95,
	"./gallery-image3": 96,
	"./gallery-image3.webp": 96,
	"./gallery-image4": 97,
	"./gallery-image4.webp": 97,
	"./gallery-image5": 98,
	"./gallery-image5.webp": 98,
	"./gallery-image6": 99,
	"./gallery-image6.webp": 99,
	"./gallery-image7": 100,
	"./gallery-image7.webp": 100,
	"./gallery-image8": 101,
	"./gallery-image8.webp": 101,
	"./gallery-image9": 102,
	"./gallery-image9.webp": 102,
	"./gift-card": 103,
	"./gift-card.png": 103,
	"./google-color": 104,
	"./google-color.svg": 104,
	"./google-plus": 105,
	"./google-plus.png": 105,
	"./grubhub": 106,
	"./grubhub.svg": 106,
	"./header-logo": 107,
	"./header-logo.svg": 107,
	"./header_logo": 108,
	"./header_logo.png": 108,
	"./ic_map": 109,
	"./ic_map.svg": 109,
	"./image1": 110,
	"./image1.png": 110,
	"./image2": 111,
	"./image2.png": 111,
	"./image3": 112,
	"./image3.png": 112,
	"./image4": 113,
	"./image4.png": 113,
	"./image5": 114,
	"./image5.png": 114,
	"./image6": 115,
	"./image6.png": 115,
	"./linkedin": 116,
	"./linkedin.png": 116,
	"./location": 49,
	"./location.png": 49,
	"./location.svg": 153,
	"./logo": 117,
	"./logo-black": 118,
	"./logo-black.png": 118,
	"./logo.png": 117,
	"./map": 119,
	"./map.png": 119,
	"./pinterest": 120,
	"./pinterest.png": 120,
	"./postmates": 121,
	"./postmates.svg": 121,
	"./seamless": 122,
	"./seamless.svg": 122,
	"./search": 123,
	"./search.png": 123,
	"./shopping-cart": 124,
	"./shopping-cart.png": 124,
	"./snack-logo-black": 125,
	"./snack-logo-black.svg": 125,
	"./sub": 126,
	"./sub.svg": 126,
	"./uber_eats": 127,
	"./uber_eats.svg": 127,
	"./user": 128,
	"./user.png": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;